import { CommonTextPropsInterface } from 'common/types/CommonTextPropsInterface'
import {
  fontCss,
  lineHeightCss,
  mobileFontCss,
  mobileLineHeightCss,
} from 'common/utils/styleUtilsNew'
import styled, { css } from 'styled-components'

type PaymentMethodLabelUiProps = Omit<
  CommonTextPropsInterface,
  'fontFileId' | 'mobileFontFileId'
>

const PaymentMethodLabelUi = styled.span<PaymentMethodLabelUiProps>`
  ${fontCss};
  ${lineHeightCss}
  ${p => p.theme.phone} {
    ${mobileFontCss};
    ${mobileLineHeightCss}
  }
  ${p =>
    p.theme.isEditorMobileMode &&
    css`
      ${mobileFontCss};
      ${mobileLineHeightCss}
    `}
`

export default PaymentMethodLabelUi
